<template>
  <BaseCleanPopup
    v-zindex
    v-body
    @close="$emit('close')"
    :h="30"
    :winh="600"
    :winw="500"
    :noneOverlay="true"
    :mini_title="'מפרש - ' + book.name"
    :mini="true"
  >
    <template v-slot:header>
      <span class="header">
        <div>
          <span class="BookInfo">{{ book.name }}</span>
          <span class="BookAuth">{{ book.authors_0_name }}</span>
        </div>
        <div class="header-buttons font-icon">
          <span @click="showSection = !showSection"
            >הצג {{ showSection ? "עמוד" : "קטע" }}</span
          >
          <span v-tooltip="'פתח ספר'" @click="openBook">N</span>
          <span
            v-if="!showSection"
            v-tooltip="mask ? 'הצג רקע' : 'הסתר רקע'"
            @click="mask = !mask"
            >H</span
          >
        </div>
      </span>
    </template>
    <div ref="bookContainer" class="book-container">
      <div v-if="showSection">
        <h1 v-if="shiurTitle">{{ subjectHeader }}</h1>
        <canvas ref="canvas" style="width: 100%; min-width: 20vw"></canvas>
      </div>
      <template v-else>
        <div v-for="(page, i) in pages" :key="page.pageNum">
          <hr v-if="i > 0 && i < pages.length" />
          <pageView
            :page="page"
            @loaded="i == 0 ? scrollStartShiur() : null"
            :mask="mask"
          >
          </pageView>
        </div>
      </template>
    </div>
  </BaseCleanPopup>
</template>

<script>
import pageView from "@/components/mefo/pageView.vue";
import winManager from "@/services/book_win";
import { rambamTiferetBooks } from "@/services/bookData";
export default {
  components: { pageView },
  props: [
    "pages",
    "rectsImg",
    "canvases",
    "book",
    "clearStart",
    "spaceBottom",
    "shiurTitle",
  ],
  data() {
    return { showSection: false, mask: true };
  },
  computed: {
    subjectHeader() {   
      if (rambamTiferetBooks.includes(this.book.id)) return "חיפוש ממוקד";
      else return `נושא: ${shiurTitle}`;
    },
  },
  async created() {
    if (this.showSection) this.drawSection();
  },
  methods: {
    async scrollStartShiur() {
      if (this.clearStart) {
        const yMinus = Object.values(this.pages[0].columns)[0].marks[0].y;
        // await new Promise((res, rej) => {
        //   let t = setInterval(() => {
        //     if (this.$refs.bookContainer) res(clearInterval(t));
        //   }, 1);
        // });
        this.$nextTick(() => {
          const h = this.$refs.bookContainer.getBoundingClientRect().height;
          this.$refs.bookContainer.scrollTop += h * yMinus + 30;
        });
      }
    },
    async drawSection() {
      // await new Promise((res, rej) => {
      //   let t = setInterval(() => {
      //     this.canvas = this.$refs.canvas;
      //     if (this.canvas) res(clearInterval(t));
      //   }, 1);
      // });
      this.$nextTick(() => {
        this.canvas = this.$refs.canvas;
        const canvas = this.$refs.canvas;
        const ctx = canvas.getContext("2d");

        const imgsToDraw = this.canvases;
        const maxW = Math.max(...imgsToDraw.map((c) => c.width));

        const spaceBottom = this.spaceBottom; //space between pharagrphs

        let height = 0;
        for (const cvs of imgsToDraw) height += cvs.height + this.spaceBottom;

        canvas.width = maxW;
        canvas.height = height;

        let y = 0;
        for (const cvs of imgsToDraw) {
          ctx.drawImage(cvs, 0, y);
          y += cvs.height + spaceBottom;
        }
      });
    },
    openBook() {
      let m = this.pages[0].columns[0].marks[0];
      winManager.createWinBook(m.book, "PID_" + m.page);
      this.$emit("close");
    },
  },
  watch: {
    showSection: function () {
      this.drawSection();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  width: 400px;
}
.header-buttons {
  display: flex;
}
.header-buttons span {
  //   display: flex;
  //   background-color: aliceblue;
  cursor: pointer;
  border-radius: 0.4rem;
  margin: 0px 1px;
  padding: 1px;
}
.header-buttons span:hover {
  background-color: #00000014;
  cursor: pointer;
}
.info-container {
  min-height: 31px;
  display: flex;
  align-items: center;
}
.BookInfo {
  /* margin-right: 10px; */
  margin-left: 4px;
  // font-size: 0.875rem;
  font-weight: 700;
  line-height: 14px;
  display: inline-block;
  width: fit-content;
  white-space: nowrap;
}
.BookAuth {
  /* opacity: 0.5; */
  font-weight: 400;
  font-size: 13px;
  line-height: 14px;
  display: inline-block;
  flex-grow: 1;
  height: 13px;
  text-overflow: ellipsis;
  /* overflow: hidden; */
  white-space: nowrap;
  overflow: hidden;
  /* display: flex; */
  align-items: center;
}
.flex-width-fit {
  flex: 1;
  /* flex-direction: r; */
  overflow: hidden;
  max-width: 100%;
  max-height: 20px;
  white-space: nowrap;
  display: flex;
}
.book-container {
  padding: 15px;
  overflow: auto;
  height: 100%;
}
</style>
